import { Component, OnInit } from '@angular/core';

@Component({
    selector: 're-administration',
    templateUrl: './administration.component.html',
    styleUrls: ['./administration.component.scss'],
    standalone: false
})
export class AdministrationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
